import * as React from 'react';

import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import CartContainerView from '../../views/library/cart-container.view';

import { flatMap, throttle } from 'lodash';
import { connect } from 'react-redux';
import { IPerformanceGroup } from '../../custom/classes/production';
import { getCartItemDetails, isPricingSelected } from '../../helpers/cart-helpers';
import { sumPrices } from '../../helpers/pricing-helpers';
import { IPackageListingAppState } from '../../redux-state';
import { processPackage } from '../../redux-state/actions/package-api.actions';
import { toggleMiniCart } from '../../redux-state/actions/package-listing.actions';

interface StateToProps {
    text: IPackageListingAppText;
    cartItems: Map<number, number>;
    //cartPackage: Map<IPackage, number>;
    cartPerformancesInPerfGroup: Map<number, Array<number>>;
    packageMin: number;
    packageMax: number;
    performanceGroups: Array<IPerformanceGroup>;
    isUnseatedReservation: boolean;
    selectedPricing: boolean;
    packageSubTotal: number;
    requiresPerformanceGroups: boolean;
    miniCartOpen: boolean;
    containsMixedSeatPerformances: boolean;
}

interface DispatchToProps {
    processPackageClick: () => void;
    toggleMiniCart: (openMiniCart: boolean) => void;
}

interface ExternalProps {
    updateStickyCart: () => void;
}

export interface CartContainerState {
    showCartLink: boolean
}

export type CartContainerProps = StateToProps & DispatchToProps & ExternalProps;
export type CartContainerViewProps = CartContainerProps;

// Pixel distance from top where cart link is hidden
const cartLinkOffset = 300;
// It feels awkward when the link hides exactly when the minicart hits the window, so this is the distance where it shows above the minicart
const cartLinkShowBuffer = 300;

export class CartContainerBase extends React.Component<CartContainerProps, CartContainerState>
{
    constructor(props: CartContainerProps) {
        super(props);
        this.state = {
            showCartLink: false
        };
    }

    checkScroll() {
        const pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,
            document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        const miniCart = document.querySelector('#miniCart') as HTMLElement;
        const cartLinkBottomOffset = miniCart ? pageHeight - miniCart.offsetTop : 0;
        const offsetFromBottom = pageHeight - document.documentElement.offsetHeight - cartLinkBottomOffset + cartLinkShowBuffer;
        const pageOffset = window.pageYOffset;
        this.setState({
            showCartLink: pageOffset > cartLinkOffset && pageOffset < offsetFromBottom
        })
    }

    private boundScroll = throttle(this.checkScroll.bind(this), 50);

    componentWillUnmount() {
        window.removeEventListener('scroll', this.boundScroll.bind(this));
    }

    componentDidMount() {
        this.checkScroll();
        window.addEventListener('scroll', this.boundScroll);
    }

    render() {
        return (<CartContainerView {...this.state} {...this.props} />
        )
    }

}
function mapStateToProps(state: IPackageListingAppState): StateToProps {
    let mappedPerfs = new Map<number, Array<number>>();

    if (!state.packageListingSettings.isFixed) {

        state.packageListing.packageDetail.performanceGroupDetails.forEach(pg => {
            let groupPerfIds = pg.tessPerformances.map(p => p.performanceId);
            mappedPerfs.set(pg.id, Array.from(state.packageListing.cartItems.keys()).filter(p => groupPerfIds.indexOf(p) >= 0));
        });
    }

    const priceSum = getPackageSubTotal(state);

    const selectedPriceTypes = state.packageListingSettings.useUnseatedReservation ? state.packageListing.totalNumberOfTicket > 0 : true;

    let selectedPricing = selectedPriceTypes;
    if (state.packageListing.isMixedFlexPackage && state.packageListing.cartItems.size > 0) {
        selectedPricing = selectedPriceTypes && isPricingSelected(state);
    } else {
        selectedPricing = selectedPriceTypes && (state.packageListingSettings.useUnseatedReservation ?
            Array.from(state.packageListing.cartItems.values()).every(zone => zone > 0)
            : true);
    }

    var props = {
        miniCartOpen: state.packageListing.miniCartOpen,
        isUnseatedReservation: state.packageListingSettings.useUnseatedReservation,
        text: state.packageListingText,
        cartItems: state.packageListing.cartItems,
        selectedPricing: selectedPricing,
        cartPerformancesInPerfGroup: mappedPerfs,
        packageSubTotal: priceSum,
        requiresPerformanceGroups: state.packageListing.packageDetail == null ? false
            : (state.packageListing.packageDetail.performanceGroupDetails.length > 1
                && state.packageListing.packageDetail.performanceGroupDetails.filter(pg => pg.minimumPerformances > 0
                    || pg.maximumPerformances != state.packageListing.packageDetail.maximumPerformances).length > 0),

    };

    if (!state.packageListingSettings.isFixed) {
        return {
            ...props,
            packageMax: state.packageListing.packageDetail.maximumPerformances,
            packageMin: state.packageListing.packageDetail.minimumPerformances,
            performanceGroups: state.packageListing.packageDetail.performanceGroupDetails,
            containsMixedSeatPerformances: state.packageListing.isMixedFlexPackage
        }
    } else {
        return {
            ...props,
            packageMax: null,
            packageMin: null,
            performanceGroups: flatMap(state.packageListing.packages.map(p => p.performanceGroupDetails)),
            containsMixedSeatPerformances: false
        }
    }

}


function getPackageSubTotal(state: IPackageListingAppState) {
    var priceList = [];

    if (state.packageListing.cartItems.size > 0) {
        for (let entry of state.packageListing.cartItems.entries()) {
            if (entry !== undefined && entry !== null) {
                var performancePricing = state.packageListing.performancePricingList
                    .get(entry[0]);

                var itemDetail = getCartItemDetails(state, entry[0]);
                if (!performancePricing) {
                    performancePricing = state.packageListing.performancePricingList.get(itemDetail.itemIdToRemove);
                }
                if (performancePricing) {
                    var matchedZone = performancePricing.zones.filter(z => z.zone.id === entry[1])[0];
                    if (matchedZone) {
                        priceList.push(sumPrices(matchedZone, state.packageListing.priceTypeQuantity).priceSum);
                    }
                }
            }
        }
        //}
    }
    const priceSum = priceList.reduce((total, num) => total + num, 0);
    return priceSum;
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        processPackageClick: () => {
            dispatch(processPackage());
        },
        toggleMiniCart: (open) => dispatch(toggleMiniCart(open))

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(CartContainerBase);